export enum LeadChangeReason {
  MODIFICATION = 'MODIFICATION',
  RENEWAL = 'RENEWAL',
  INSURER_CHANGE = 'INSURER_CHANGE',
  OTHER = 'OTHER',
  PREMIUM_INCREASE = 'PREMIUM_INCREASE',
  PREMIUM_DECREASE = 'PREMIUM_DECREASE',
}

const CHANGE_REASON_SORT_ORDER: Record<string, number> = {
  [LeadChangeReason.MODIFICATION]: 0,
  [LeadChangeReason.RENEWAL]: 1,
  [LeadChangeReason.INSURER_CHANGE]: 2,
  [LeadChangeReason.OTHER]: 3,
  [LeadChangeReason.PREMIUM_INCREASE]: 4,
  [LeadChangeReason.PREMIUM_DECREASE]: 5,
};

const ENUM_VALUES = new Set(Object.values(LeadChangeReason));

export const getLeadChangeReasonLabel = (
  value: LeadChangeReason | string
): string => {
  switch (value) {
    case LeadChangeReason.MODIFICATION:
      return $localize`Modification`;
    case LeadChangeReason.RENEWAL:
      return $localize`Renouvellement`;
    case LeadChangeReason.INSURER_CHANGE:
      return $localize`Changement d'assureur`;
    case LeadChangeReason.OTHER:
      return $localize`Autre`;
    case LeadChangeReason.PREMIUM_INCREASE:
      return $localize`Augmentation`;
    case LeadChangeReason.PREMIUM_DECREASE:
      return $localize`Diminution`;
    default:
      return value;
  }
};

export const normalizeChangeReason = (
  value: string | string[] | null | undefined
): string[] => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  return [value];
};

export const getChangeReasonSortIndex = (value: string): number => {
  if (value in CHANGE_REASON_SORT_ORDER) {
    return CHANGE_REASON_SORT_ORDER[value];
  }
  return 3;
};

export const getPrimaryChangeReason = (
  changeReasons: string | string[] | null | undefined
): string => {
  const list = normalizeChangeReason(changeReasons);
  if (!list.length) return '';
  return [...list].sort(
    (a, b) => getChangeReasonSortIndex(a) - getChangeReasonSortIndex(b)
  )[0];
};

export const isKnownLeadChangeReason = (
  value: string
): value is LeadChangeReason => ENUM_VALUES.has(value as LeadChangeReason);

export const EXCLUSIVE_CHANGE_REASON_GROUPS = [
  [LeadChangeReason.MODIFICATION, LeadChangeReason.INSURER_CHANGE],
  [LeadChangeReason.RENEWAL, LeadChangeReason.INSURER_CHANGE],
  [LeadChangeReason.PREMIUM_INCREASE, LeadChangeReason.PREMIUM_DECREASE],
];
